import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { DetailsChargingStationDialogContentComponent } from './details-charging-station-dialog-content/details-charging-station-dialog-content.component';

@Component({
  selector: 'app-details-charging-station-dialog',
  template: ''
})
export class DetailsChargingStationDialogComponent implements OnInit {

  public isOperatorView: boolean;
  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;
  public size: string = 'xl';
  private sortParam;

  constructor(
    public dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.getRoles();
    this.activatedRoute.paramMap.subscribe(params => {
      this.routeDataService.params = this.activatedRoute.snapshot.params;
      this.openDialog();
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.sortParam = params.sort;
    });
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
      // this.size = 'md';
    }
  }


  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;
    const dialogRef = this.dialog.open(DetailsChargingStationDialogContentComponent, { size: this.size, backdrop: 'static', keyboard: false });
    // const dialogRef = this.dialog.open(DetailsChargingStationDialogContentComponent, { size: this.size, centered: true, backdrop: 'static', keyboard: false });

    dialogRef.componentInstance.customerId = customerId;

    if (this.operator) {
      this.isOperatorView = true;
      dialogRef.componentInstance.isOperatorView = true;
    }

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute, queryParams: { sort: this.sortParam } });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute, queryParams: { sort: this.sortParam } });
    });
  }

}
